module.exports = __webpack_public_path__ + "media/icon_transaction/rabit_2-2c19b5cd.png";